//
// Copyright 2024 DXOS.org
//

import React, { useEffect, useRef, useState } from 'react';

import * as Button from '@dxos/react-ui/Button';
import { mx } from '@dxos/ui-theme';

import { styles } from './styles.ts';

// TODO(burdon): Reconcile with DebugPlugin.
export const ErrorIndicator = () => {
  const [, forceUpdate] = useState({});
  const errorRef = useRef<Error>(null);
  useEffect(() => {
    const errorListener = (event: any) => {
      const error: Error = event.error ?? event.reason;
      // event.preventDefault();
      if (errorRef.current !== error) {
        errorRef.current = error;
        forceUpdate({});
      }
    };

    // TODO(burdon): Register globally?
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
    window.addEventListener('error', errorListener);

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
    window.addEventListener('unhandledrejection', errorListener);

    return () => {
      window.removeEventListener('error', errorListener);
      window.removeEventListener('unhandledrejection', errorListener);
    };
  }, []);

  return (
    <Button.Root
      classNames={mx(errorRef.current ? styles.error : styles.default)}
      variant='ghost'
      icon='ph--circle--fill'
      iconOnly
      label={errorRef.current?.message ?? 'No errors.'}
      onClick={() => {
        errorRef.current = null;
        forceUpdate({});
      }}
    />
  );
};
